var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeployment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2887_9541)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 0.748047,
    width: 58,
    height: 58,
    rx: 8,
    fill: "#346F98"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 0.748047,
    width: 58,
    height: 58,
    rx: 8,
    fill: "url(#paint0_linear_2887_9541)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2887_9541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.25 41.8317L41.875 38.2067L41.0292 37.3609L38.8542 39.5359V34.5817H37.6458V39.5359L35.4708 37.3609L34.625 38.2067L38.25 41.8317ZM31 28.3588L23.8406 24.2202L22.5417 24.9755V26.2442L31 31.138L39.4583 26.2442V24.9755L38.1594 24.2202L31 28.3588ZM29.7917 41.4994L21.3333 36.6359C20.9507 36.4143 20.6536 36.1223 20.4422 35.7598C20.2307 35.3973 20.125 34.9946 20.125 34.5515V24.9452C20.125 24.5022 20.2307 24.0994 20.4422 23.7369C20.6536 23.3744 20.9507 23.0824 21.3333 22.8609L29.7917 17.9973C30.1743 17.7758 30.5771 17.665 31 17.665C31.4229 17.665 31.8257 17.7758 32.2083 17.9973L40.6667 22.8609C41.0493 23.0824 41.3464 23.3744 41.5578 23.7369C41.7693 24.0994 41.875 24.5022 41.875 24.9452V30.564C41.3312 30.3022 40.7523 30.1008 40.138 29.9598C39.5238 29.8189 38.8944 29.7484 38.25 29.7484C35.9139 29.7484 33.9201 30.5741 32.2687 32.2255C30.6174 33.8768 29.7917 35.8706 29.7917 38.2067C29.7917 38.8511 29.8571 39.4704 29.988 40.0645C30.1189 40.6586 30.3153 41.2275 30.5771 41.7713C30.4361 41.731 30.3002 41.6958 30.1693 41.6656C30.0384 41.6354 29.9125 41.58 29.7917 41.4994ZM38.25 44.2484C36.5785 44.2484 35.1536 43.6593 33.9755 42.4812C32.7974 41.3031 32.2083 39.8782 32.2083 38.2067C32.2083 36.5352 32.7974 35.1104 33.9755 33.9322C35.1536 32.7541 36.5785 32.165 38.25 32.165C39.9215 32.165 41.3464 32.7541 42.5245 33.9322C43.7026 35.1104 44.2917 36.5352 44.2917 38.2067C44.2917 39.8782 43.7026 41.3031 42.5245 42.4812C41.3464 43.6593 39.9215 44.2484 38.25 44.2484Z",
    fill: "#E9E9E9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2887_9541",
    x: 0.791667,
    y: 0.748047,
    width: 60.4167,
    height: 60.4167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.20833
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.604167
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2887_9541"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2887_9541",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2887_9541",
    x1: 31,
    y1: 0.748047,
    x2: 31,
    y2: 58.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DD6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2887_9541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white",
    transform: "translate(16.5 15.248)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeployment);
export default __webpack_public_path__ + "static/media/deployment.1fd7cfca9e22d01947812ad1ce761d98.svg";
export { ForwardRef as ReactComponent };